import { useMemo } from 'react';
import { api } from '../../store/api-generated';
import { DISABLE_AUTH } from '../../config/constants';


export default function useAuth() {
  const { data, isError } = api.endpoints.session.useQueryState();
  const authStatus = useMemo(() => {
    if (DISABLE_AUTH) {
      // temporarily disable login during servermigration
      return 'Unauthorized';
    }

    if (isError) {
      return 'Error';
    }

    if (!!data && 'isAuthenticated' in data && data.isAuthenticated) {
      return 'Authorized';
    }

    if (!!data && 'isAuthenticated' in data && !data.isAuthenticated) {
      return 'Unauthorized';
    }

    return 'Unknown';
  }, [data, isError]);

  return {
    state: process.env.NODE_ENV === 'development' ? process.env.AUTH_STATUS as typeof authStatus : authStatus,
  } as const;
}
